<template>
  <div class="animated fadeIn">
    <b-card>
      <vue-loading :active.sync="absencesTableProps.isLoading" :is-full-page="false"/>
      <vue-loading :active.sync="isLoadingDeleting" :is-full-page="false"/>
      <div slot="header">
        <b>Odsotnosti</b>
        <div class="card-header-actions">
          <CLink title="Osveži tabelo" href="#" class="card-header-action btn-setting" @click.stop="click_absencesTableRefresh">
            <CIcon name="cil-loop-circular"/>
          </CLink>
          <CLink title="Ponastavi filtre" href="#" class="card-header-action btn-setting" @click.stop="click_absencesTableResetFilters">
            <CIcon name="cil-x"/>
          </CLink>
          <CLink title="Dodaj odsotnost" href="#" class="card-header-action btn-setting" @click.stop="click_absenceCreate">
            <CIcon name="cil-plus"/>
          </CLink>
        </div>
      </div>

      <div class="table-filters-wrap">
        <div class="single-filter-wrap">
          <label for="search-filter">Iskanje</label>
          <b-form-input
              v-model="absencesTableProps.inputFilter.search"
              type="text"
              id="search-filter"
              @input="absencesTableTextFilter_change"/>
        </div>
        <div class="single-filter-wrap">
          <v-date-picker
              locale="sl-SI"
              v-model="absencesTableProps.inputFilter.dateFrom"
              @input="absencesTableTextFilter_change"
              :model-config=" {
									type: 'string',
								}"
              timezone='utc'>
            <template v-slot="{ inputValue, inputEvents }">
              <CInput
                  label="Datum od"
                  :value="inputValue"
                  v-on="inputEvents"/>
            </template>
          </v-date-picker>
        </div>
        <div class="single-filter-wrap">
          <v-date-picker
              locale="sl-SI"
              v-model="absencesTableProps.inputFilter.dateTo"
              @input="absencesTableTextFilter_change"
              :model-config=" {
									type: 'string',
								}"
              timezone='utc'>
            <template v-slot="{ inputValue, inputEvents }">
              <CInput
                  label="Datum do"
                  :value="inputValue"
                  v-on="inputEvents"/>
            </template>
          </v-date-picker>
        </div>
        <div class="single-filter-wrap">
          <label for="reason-filter">Razlog</label>
          <b-form-select
              v-model="absencesTableProps.inputFilter.reason"
              id="reason-filter"
              :options="absenceReasons"
              @input="absencesTableTextFilter_change"></b-form-select>
        </div>
      </div>

      <b-table
          ref="absencesTable"
          responsive="sm"
          striped
          show-empty
          hover
          :empty-text="absencesTableProps.empty_text"
          :empty-filtered-text="absencesTableProps.empty_filtered_text"
          :fields="absencesTableProps.fields"
          :current-page="absencesTableProps.currentPage"
          :per-page="absencesTableProps.itemsPerPage"
          :items="absencesTable_items">
        <template v-slot:cell(start_date)="data">
          {{ data.item.start_date | viewDate }}
        </template>
        <template v-slot:cell(end_date)="data">
          {{ data.item.end_date | viewDate }}
        </template>
        <template v-slot:cell(reason)="data">
          {{ formatReason(data.item.reason) }}
        </template>
        <template v-slot:cell(actions)="data">
          <div>
            <b-button title="Edit absence" variant="primary" @click.stop="click_absenceEdit(data.item)" size="sm" class="mr-2">
              <CIcon name="cil-pencil"/>
            </b-button>
            <b-button title="Delete absence" variant="danger" @click.stop="click_absenceDelete(data.item)" size="sm" class="mr-2">
              <CIcon name="cil-trash"/>
            </b-button>
          </div>
        </template>
      </b-table>
      <nav>
        <b-row>
          <b-col>
            <b-pagination :total-rows="absencesTableProps.totalItems" :per-page="absencesTableProps.itemsPerPage" v-model="absencesTableProps.currentPage" prev-text="Prejšnja" next-text="Naslednja" hide-goto-end-buttons />
          </b-col>
          <b-col cols=2>
            <a class="page-link rows_total float-right">Št. vrstic: {{ absencesTableProps.totalItems }}</a>
          </b-col>
          <b-col cols=1>
            <b-form-select v-model="absencesTableProps.itemsPerPage" :options="absencesTableProps.options_numRowsOnPage"></b-form-select>
          </b-col>
        </b-row>
      </nav>
    </b-card>
    <absence-create-edit-modal ref="absenceCreateEditModal" @emit_absenceCreatedOrEdited="emit_absenceCreatedOrEdited"/>
    <vue-toastr ref="toastr"></vue-toastr>
  </div>
</template>

<script>
import settings from '@/settings.js';
import { ABSENCES_LIST, ABSENCE_DELETE } from "@/store/actions/absences";
import AbsenceCreateEdit from "@/views/modals/AbsenceCreateEdit.vue";

export default {
  name: 'Absences',
  components: {
    'absence-create-edit-modal': AbsenceCreateEdit
  },
  data () {
    return {
      absencesTableProps: {
        fields: [
          { key: 'id', label: 'Id', sortable: true, class: 'tdAbsencesId' },
          { key: 'user_name', label: 'Uporabnik', sortable: true, class: '' },
          { key: 'start_date', label: 'Začetni datum', sortable: true, class: '' },
          { key: 'end_date', label: 'Končni datum', sortable: true, class: '' },
          { key: 'reason', label: 'Razlog', sortable: true, class: '' },
          { key: 'note', label: 'Opomba', sortable: true, class: '' },
          { key: 'actions', label: '#', sortable: false, class: 'tdAbsencesActions' },
        ],
        currentPage: 1,
        itemsPerPage: 50,
        totalItems: 0,
        isLoading: false,
        options_numRowsOnPage: [
          { value: 50, text: '50' },
          { value: 100, text: '100' },
          { value: 200, text: '200' },
          { value: 1000, text: '1000' }
        ],
        empty_text: '',
        empty_filtered_text: 'Ni zadetkov',
        inputFilter: {
          search: null,
          dateFrom: new Date().toISOString().split('T')[0],
          dateTo: `${new Date().getFullYear()}-12-31`,
          reason: null,
        },
        textFilterTimeout: null,
        errorText: ''
      },
      isLoadingDeleting: false,
      absenceReasons: {
        0: 'Neznano',
        1: 'Dopust',
        2: 'Bolniški dopust'
      }
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    click_absenceCreate: function () {
      let modalInput = {
        mode: 1, // create
        modalAbsence: null
      }
      this.$refs.absenceCreateEditModal.showModal(modalInput);
    },
    click_absenceEdit: function (data) {
      let modalInput = {
        mode: 2, // edit
        modalAbsence: data
      }
      this.$refs.absenceCreateEditModal.showModal(modalInput);
    },
    click_absenceDelete: function (data) {
      this.$bvModal.msgBoxConfirm('Želite izbrisati odsotnost (#' + data.id + ')?', {
        title: 'Potrdite brisanje odsotnosti',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'DA',
        cancelTitle: 'NE',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value === true) {
          this.isLoadingDeleting = true;
          this.$store.dispatch(ABSENCE_DELETE, { id: data.id })
              .then((responseData) => {
                this.isLoadingDeleting = false;
                this.$refs.toastr.s('Odsotnost (#' + data.id + ') uspešno izbrisana.');
                this.$refs.absencesTable.refresh();
              })
              .catch(error => {
                this.isLoadingDeleting = false;
                console.error(error);
                if(error.response && error.response.data && error.response.data.code) {
                  this.$refs.toastr.e('Napaka pri brisanju! (' + error.response.data.code + ')');
                } else {
                  this.$refs.toastr.e('Napaka pri brisanju! Prosimo poizkusite kasneje.');
                }
              });
        }
      }).catch(err => {
        console.error(err);
      })
    },
    click_absencesTableRefresh: function () {
      this.$refs.absencesTable.refresh();
    },
    click_absencesTableResetFilters: function () {
      this.absencesTableProps.inputFilter.search = null;
      this.absencesTableProps.inputFilter.reason = null;
      this.absencesTableProps.inputFilter.dateFrom = null;
      this.absencesTableProps.inputFilter.dateTo = null;
      this.$refs.absencesTable.refresh();
    },
    emit_absenceCreatedOrEdited: function (data) {
      if (data.message === 'created') {
        this.$refs.toastr.s('Odsotnost #' + data.absence.id + ' uspešno dodana.');
      } else if (data.message === 'edited') {
        this.$refs.toastr.s('Odsotnost #' + data.absence.id + ' uspešno urejena.');
      } else {
        this.$refs.toastr.e('Neznan odziv strežnika.');
      }
      this.$refs.absencesTable.refresh();
    },
    absencesTable_items: function (ctx) {
      this.absencesTableProps.isLoading = true;
      return this.$store.dispatch(ABSENCES_LIST, { ctx: ctx, tableProps: this.absencesTableProps })
          .then((responseData) => {
            this.absencesTableProps.isLoading = false;
            this.absencesTableProps.items = responseData.absences.data;
            this.absencesTableProps.totalItems = responseData.absences.total;
            this.absencesTableProps.empty_text = 'Ni vnosov';
            return responseData.absences.data;
          })
          .catch(error => {
            this.absencesTableProps.isLoading = false;
            this.absencesTableProps.items = [];
            this.absencesTableProps.totalItems = 0;
            this.absencesTableProps.empty_text = 'Napaka pri pridobivanju podatkov';
            console.log(error);
            return [];
          });
    },
    absencesTableTextFilter_change: function (value) {
      if (this.absencesTableProps.textFilterTimeout !== null) {
        clearTimeout(this.absencesTableProps.textFilterTimeout);
      }
      this.absencesTableProps.textFilterTimeout = setTimeout(() => {
        this.$refs.absencesTable.refresh();
      }, settings.filterTimeoutLength);
    },
    formatReason(reason_id) {
      return this.absenceReasons[reason_id] || 'Neznano';
    },
  },
  created: function () {
  }
}
</script>
<style scoped>
.table-responsive-sm {
  margin-bottom: 0;
}
.pagination {
  margin-left: 1rem;
  margin-right: 1rem;
}
.page-link.rows_total {
  text-align: center;
  border-radius: 5px;
  width: 120px;
}
.table-filters-wrap {
  margin-bottom: 15px;
  float: left;
}
.single-filter-wrap {
  width: 200px;
  float: left;
  margin-right: 15px;
}
</style>

<style>
.tdAbsencesId {
  width: 120px;
}
.tdAbsencesActions {
  width: 120px;
}
</style>